import type { LucideIcon } from "lucide-react"
import { FileQuestion } from "lucide-react"
import type { ReactNode } from "react"

export function EmptyState({
	icon: Icon = FileQuestion,
	title,
	children,
	action,
}: {
	icon?: LucideIcon
	title: string
	children?: ReactNode
	action?: ReactNode
}) {
	return (
		<div className="rounded-3xl border border-dashed border-white/15 px-6 py-10 text-center">
			<Icon className="mx-auto mb-3 size-8 text-muted-foreground" />
			<p className="font-medium">{title}</p>
			{children ? <div className="mt-1 text-sm text-muted-foreground">{children}</div> : null}
			{action ? <div className="mt-4">{action}</div> : null}
		</div>
	)
}
